import { gql } from "@apollo/client";

const GET_EWP_SETTINGS = gql`
query ewpConnections
    {ewpConnections{
        api_iia
        api_ola 
        api_static
        api_ounits
        api_nomination
    }

    
}`
;

export default GET_EWP_SETTINGS;
